import React from "react";
import Footer from "../footer/Footer";
import Header from "../header/Header";
import VTAdminDashboardNew2 from "../page/VTAdminDashboardNew2";

/**
 * Admin Dashboard View
 *
 * @param page
 * @returns {JSX.Element}
 * @constructor
 */
export default function LandingAdminDashboard({page}) {
    return (
        <>
            <Header headerType="AdminOnly"/>
            <VTAdminDashboardNew2/>
            <Footer/>
        </>
    );
}